<div #xtermContainer></div>
<button type="button" class="btn btn-primary" (click)="downloadLog()">Download Log</button>
